import axios from 'axios';

export default {
  index: (params = {}, config = {}) => axios.get('fees', { params, ...config }),
  metrics: (params = {}, config = {}) => axios.get('fees/metrics', { params, ...config }),
  store: (payload = {}, config = {}) => axios.post('fees', payload, config),
  update: (id, payload = {}, config = {}) => {
    const feeId = Number(id || 0);

    if (payload instanceof FormData) {
      payload.set('_method', 'PUT');
      return axios.post(`fees/${feeId}`, payload, config);
    }

    return axios.put(`fees/${feeId}`, payload, config);
  },
  taxPreview: (payload = {}, config = {}) => axios.post('fees/tax-preview', payload, config),
  show: (id, params = {}, config = {}) => axios.get(`fees/${id}`, { params, ...config }),
  approve: (id, payload = {}, config = {}) => axios.post(`fees/${id}/approve`, payload, config),
  pay: (id, payload = {}, config = {}) => axios.post(`fees/${id}/pay`, payload, config),
  delete: (id, config = {}) => axios.delete(`fees/${id}`, config),
  clearBySale: (saleId, config = {}) => axios.delete(`fees/sale/${saleId}/clear`, config),
};
